import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import CustomInput from "../../components/CustomInput";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Auth } from "aws-amplify";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { appLogger } from "../../utils";
import { withSnackbar } from "../../utils/common/SnackbarHoc";

const initialValues = {
  password: "",
  confirmPassword: "",
};

const validationSchema = Yup.object({
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$^*.\[\]{}\(\)\?\-\"\!@#%&\/\\,><\':;|_~`+\=])(?=.{8,20})/, //any of these should be allowed ^$*.[]{}()?-"!@#%&/\,><':;|_~`+=
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const NewPassword = ({
  email,
  user,
  handleSignIn,
  snackbarShowMessage,
}: any) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      try {
        appLogger.info({
          infoObj: {
            method: "onSubmit",
            component: "home",
            fileName: "NewPassword.tsx",
            userInfo: values,
          },
        });
        submitNewPasswordRequest(user, values.password);
      } catch (error) {
        appLogger.error({
          errObj: {
            method: "onSubmit",
            component: "home",
            fileName: "NewPassword.tsx",
            err: error,
          },
        });
      }
    },
  });

  const submitNewPasswordRequest = async (user: any, password: any) => {
    // if (!validateNewPasswords(newPassword, confirmNewpassword)) {
    // 	setLoading(false);
    // 	return;
    // }
    Auth.completeNewPassword(user, password, { email: email })
      .then((newUser) => {
        if (
          newUser &&
          newUser.signInUserSession.idToken &&
          newUser.signInUserSession.accessToken
        ) {
          appLogger.info({
            infoObj: {
              method: "submitNewPasswordRequest",
              component: "home",
              fileName: "NewPassword.tsx",
              newUser: newUser,
            },
          });

          // setLoading(false);
          handleSignIn(newUser);
        } else {
          // notifyError('Set password failed. Please try again');
          // setLoading(false);
        }
      })
      .catch((error) => {
        appLogger.error({
          errObj: {
            method: "submitNewPasswordRequest",
            component: "home",
            fileName: "NewPassword.tsx",
            err: error,
          },
        });
        if (error instanceof Error) {
          snackbarShowMessage(error.message, "error");
        } else {
          snackbarShowMessage("Unexpected error", "error");
        }
      });
  };

  const handleClickShowPassword = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleConfirmPassword = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  return (
    <Box className="form-wrap">
      <Typography component="h1" variant="h5">
        Change Password
      </Typography>

      <Typography component="h5" sx={{ mb: "10px" }}>
        Enter your new password below
      </Typography>
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        method="post"
        noValidate
        sx={{ mt: "20px" }}
      >
        <CustomInput
          placeholder="Password"
          label="Password"
          type={passwordVisible ? "text" : "password"}
          id="password"
          autoComplete="new-password"
          startAdornment={
            <InputAdornment position="start">
              <LockOpenIcon />
            </InputAdornment>
          }
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                edge="end"
              >
                {passwordVisible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          {...formik.getFieldProps("password")}
          error={
            formik.touched.password && formik.errors.password ? true : false
          }
          helperText={
            formik.touched.password && formik.errors.password
              ? formik.errors.password
              : null
          }
        />
        {/* <FormHelperText id='outlined-weight-helper-text'>
					Weight
					</FormHelperText> */}

        <CustomInput
          placeholder="Confirm Password"
          label="Confirm Password"
          type={confirmPasswordVisible ? "text" : "password"}
          id="confirmPassword"
          autoComplete="new-password"
          startAdornment={
            <InputAdornment position="start">
              <LockOpenIcon />
            </InputAdornment>
          }
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleConfirmPassword}
                edge="end"
              >
                {confirmPasswordVisible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
          {...formik.getFieldProps("confirmPassword")}
          error={
            formik.touched.confirmPassword && formik.errors.confirmPassword
              ? true
              : false
          }
          helperText={
            formik.touched.confirmPassword && formik.errors.confirmPassword
              ? formik.errors.confirmPassword
              : null
          }
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          sx={{
            mt: "15px",
            mb: "15px",
            backgroundColor: (theme: any) => theme.palette.primary.main,
            textTransform: "uppercase",
          }}
        >
          Login
        </Button>
      </Box>
    </Box>
  );
};

export default withSnackbar(NewPassword);
